import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=6d39ffcc&"
import script from "./navbar.vue?vue&type=script&lang=ts&"
export * from "./navbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports